import axios from 'axios'
import '@/service/service_pagamento/httpsemtoken'
require('@/service/service_pagamento/httpsemtoken')
const urlPagamento = localStorage.getItem('APIPagamentos')
var http = axios.create({
    baseURL: urlPagamento
})
http.defaults.headers.modulo = 4
http.defaults.headers.common['Accept'] = 'application/json'

async function addHeaderPost (headers) {
    headers.forEach(element => {
        http.defaults.headers.common[element.nome] = element.valor
        element
    })
    return 1
}
// CHAMDAS AXIOS
async function post (url, params) {
  return http.post(url, params)
}
// Export
export default {
    post, addHeaderPost
}